export default [
  {
    code: 'FLOOD',
    label: 'Banjir'
  },
  {
    code: 'FIRE',
    label: 'Kebakaran'
  },
  {
    code: 'EARTH_QUAKE',
    label: 'Gempa Bumi'
  },
  {
    code: 'VOLCANO',
    label: 'Gunung Api'
  },
  {
    code: 'TSUNAMI',
    label: 'Tsunami'
  }
]